import { connect } from "react-redux"

import {
    clusterListSearchRequest,
    clusterListInvalidationRequest,
    clusterAddNew
} from "../../../actions/cluster-actions"

import ClusterListWidget from "./ClusterListWidget"

const mapStateToProps = ({
    presentation: { clusters },
    paging,
    authentication
}) => ({
    isFetching:
        clusters.isFetchingList ||
        clusters.isFetchingItem ||
        clusters.isDeletingItem,
    pagingRequest: paging.clusters[clusters.searchCriteria],
    nameSearchTerm: clusters.workingFilterModel.title,
    isAddingEnabled: authentication.permissions.indexOf("w_cluster") !== -1
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(clusterListInvalidationRequest(pagingRequest)),
    onSearch: ({ target: { name, value } }) =>
        dispatch(clusterListSearchRequest(name, value)),
    onAdd: () => dispatch(clusterAddNew())
})

export default connect(mapStateToProps, mapDispatchToProps)(ClusterListWidget)
